import { DownloadSimpleIcon, PencilSimpleIcon, PlusIcon, TrashIcon, UploadSimpleIcon } from '@phosphor-icons/react'

import { eventIconTypes } from '../constants'

export const getEventIcons = theme => {
  const iconProps = { size: 24, color: theme.colors.text.muted }

  return {
    [eventIconTypes.edit]: <PencilSimpleIcon {...iconProps} />,
    [eventIconTypes.plus]: <PlusIcon {...iconProps} />,
    [eventIconTypes.trash]: <TrashIcon {...iconProps} />,
    [eventIconTypes.upload]: <UploadSimpleIcon {...iconProps} />,
    [eventIconTypes.download]: <DownloadSimpleIcon {...iconProps} />,
  }
}
